// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdditionalInfoLayout_wrapper__mwRRT","title-column":"AdditionalInfoLayout_title-column__VHrMc"};